<template>
    <footer id="footer" class="footer-area section-padding collapsed fixed-bottom">
        <div class="container-footer">
            <div class="container-fluid collapsed-hidden">
                <div class="row">
                    <div class="info col-lg-4 col-md-6 col-sm-12 col-xs-12">
                        <img  class="img-fluid wow fadeInUp logo" data-wow-delay="0.4s" src="../assets/img/logo-full-w.png" alt="" >
<!--                        <h5>We are committed to provide the best Integrated Behavioral Health Services</h5>-->
                        <!--              <h3 class="footer-titel">Aqui estamos</h3>-->
                        <!--              <div class="map">-->
                        <!--                <object style="border:0; height: 280px; width: 100%;" data="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d34015.943594576835!2d-106.43242624069771!3d31.677719472407432!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86e75d90e99d597b%3A0x6cd3eb9a9fcd23f1!2sCourtyard+by+Marriott+Ciudad+Juarez!5e0!3m2!1sen!2sbd!4v1533791187584"></object>-->
                        <!--              </div>-->
                    </div>
                    <div class="info col-lg-4 col-md-6 col-sm-12 col-xs-12 text-left">
                        <h3 class="footer-titel">Miami Office</h3>
                        <ul class="address">
                            <li>
                                <a href="#"><i class="lni-map-marker"></i>9245 SW 157 ST Suite 209, Palmetto Bay, FL 33157</a>
                            </li>
                            <li>
                                <a href="#"><i class="lni-phone-handset"></i> Phone: +1 786 701 2401</a>
                            </li>
                            <li>
                                <a href="#"><i class="lni-envelope"></i> Email: dttcoaching@gmail.com</a>
                            </li>
                        </ul>
                    </div>
                    <div class="info col-lg-4 col-md-6 col-sm-12 col-xs-12 text-left">
                        <h3 class="footer-titel">Broward Office</h3>
                        <ul class="address">
                            <li>
                                <a href="#"><i class="lni-map-marker"></i>6151 Miramar PKWY Suite 205
                                    Miramar, FL, 33023</a>
                            </li>
                            <li>
                                <a href="#"><i class="lni-phone-handset"></i> Phone: +1 954 505 4623</a>
                            </li>
                            <li>
                                <a href="#"><i class="lni-laptop-phone"></i> Fax: 305 397 1287</a>
                            </li>
                            <li>
                                <a href="#"><i class="lni-envelope"></i> Email: dttcoaching@gmail.com</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="container-fluid footer-mini collapsed-display ">
                <div class="row">
                    <div class="info col-lg-4 col-md-4 col-sm-12 col-xs-12 text-left title-callus">
                        <SvgAnimated :svg=animation1 />
                        <h3 class="footer-titel wow bounceIn text-center" data-wow-delay="0.2s">{{$t('news.slides.btn1')}}</h3>
                        <SvgAnimated :svg=animation2  class="arrow"/>
                    </div>
                    <div class="info col-lg-4 col-md-4 col-sm-12 col-xs-12 text-left">
                        <h3 class="footer-titel wow fadeInUp" data-wow-delay="0.1s">Miami Office</h3>
                        <div class="shape wow fadeInUp" data-wow-delay="0.1s" ></div>
                        <div class="navbar-callus text-left sm-text-center">
                            <ul class="list-inline wow fadeInUp" data-wow-delay="0.2s">
                                <li><a href="tel:+17867012401"><i class="fa fa-phone"></i> <span class="d-none d-md-block d-md-block">{{$t('phone')}}:</span> +1 786 701 2401</a></li>
<!--                                <li class="d-none d-md-block  d-lg-block"><a href="mailto:dttcoaching@gmail.com?Subject=Contacting"><i-->
<!--                                        class="fa fa-envelope-o"></i> E-mail: dttcoaching@gmail.com</a></li>-->
                            </ul>
                        </div>
                    </div>
                    <div class="info col-lg-4 col-md-4 col-sm-12 col-xs-12 text-left">
                        <h3 class="footer-titel wow fadeInUp" data-wow-delay="0.1s">Broward Office</h3>
                        <div class="shape wow fadeInUp" data-wow-delay="0.1s" ></div>
                        <div class="navbar-callus text-left sm-text-center">
                            <ul class="list-inline wow fadeInUp" data-wow-delay="0.2s">
                                <li><a href="tel:+19545054623"><i class="fa fa-phone"></i> <span class="d-none d-md-block">{{$t('phone')}}:</span> +1 954 505 4623</a></li>
<!--                                <li class="d-none d-md-block  d-lg-block"><a href="mailto:dttcoaching@gmail.com?Subject=Contacting"><i-->
<!--                                        class="fa fa-envelope-o"></i> E-mail: dttcoaching@gmail.com</a></li>-->
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div id="copyright" class="collapsed-hidden">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="copyright-content animated slideInUp">
                            <p>Copyright © 2020 <a rel="nofollow" href="http://dttcoaching.com/">DTT Coaching Services LLC</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import SvgAnimated from '../components/SvgAnimationCmp'
    import * as animationData from '../assets/img/v2/animations/audio-call-w';
    import * as animationData2 from '../assets/img/v2/animations/arrow-right';
    export default {
        name: "Footer",
        components: {
            SvgAnimated
        },
        data() {
            return {
                animation1: animationData,
                animation2: animationData2
            }
        }
    }
</script>

<style scoped>

</style>
